import type { BrowserAppSessionBootstrapConfig, BrowserAppSessionBootstrapResult } from "./types";

export async function bootstrapBrowserAppSession<TUser, TContext = unknown>(
  config: BrowserAppSessionBootstrapConfig<TUser, TContext>,
  fetchImpl: typeof fetch = fetch,
): Promise<BrowserAppSessionBootstrapResult<TUser, TContext>> {
  const appUser = await config.bootstrapAppSession(fetchImpl);
  if (!appUser) {
    config.clearSession?.();
    return {
      appContext: null,
      currentUser: null,
    };
  }

  const appContext = config.loadAppContext ? await config.loadAppContext(fetchImpl, appUser) : null;

  return {
    appContext,
    currentUser: appUser,
  };
}
